import AutoPayScreen from 'features/lineOfCredit/screens/autopay/AutoPayScreen';
import React from 'react';

export default function Page() {
  return <AutoPayScreen />;
}
